import React from 'react';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";



const ClassDisplay = ({classi}) => {
    return (
        <Grid spacing={3} container>
            <Grid  item>
                Class
            </Grid>
            <Grid  item>
                <Typography  variant="h2">    {classi}</Typography>

            </Grid>

        </Grid>
    );
};




const VisitResultClass = ({category,height=100}) => {
    return (
        <div>
            {category === 'A'&&
                <Card style={{backgroundColor:'#8db61b',color:'#FFF'}}>
                    <CardContent>
                       <ClassDisplay classi={category}/>
                        <h5>Can Manage without finado fund</h5>
                    </CardContent>
                </Card>
            }
            {category === 'B'&& <Card style={{backgroundColor:'#d5a821',color:'#FFF'}}>
                <CardContent>
                    <ClassDisplay classi={category}/>
                    <h5>Can Manage only with finado fund</h5>
                </CardContent>
            </Card>}
            {category === 'C'&& <Card style={{backgroundColor:'#b64c1b',color:'#FFF'}}>
                <CardContent>
                    <ClassDisplay classi={category}/>
                    <h5>Can't Manage even with finado fund</h5>
                </CardContent>
            </Card>}
        </div>
    );
};

export default VisitResultClass;
